<template>
  <!-- 登录界面窗体 -->
  <div class="login">
    <!-- 登录表单 -->
    <p class="loginTitle">
      <!-- <img :src="logoImg" alt="" /> -->
      通 航 飞 行 管 控 系 统
    </p>
    <!-- 登录表单 -->
    <div class="loginForm">
      <p class="loginInfo">用&nbsp;&nbsp;户&nbsp;&nbsp;登&nbsp;&nbsp;录</p>
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        class="ruleForm"
      >
        <el-form-item label prop="username">
          <el-input
            type="text"
            v-model="ruleForm.username"
            autocomplete="off"
            prefix-icon="el-icon-user"
            placeholder="请 输 入 用 户 名"
            @keypress.native.enter="submitForm('ruleForm')"
          ></el-input>
        </el-form-item>
        <el-form-item label prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            autocomplete="off"
            prefix-icon="el-icon-lock"
            placeholder="请 输 入 密 码"
            @keypress.native.enter="submitForm('ruleForm')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="ruleForm.checked" style="float: left"
            >记&nbsp;住&nbsp;密&nbsp;码</el-checkbox
          >
          <!-- <el-link type="primary" style="float: right">忘&nbsp;记&nbsp;密&nbsp;码&nbsp;?</el-link> -->
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
            @keyup.enter="submitForm('ruleForm')"
            class="loginBtn"
            >登&nbsp;&nbsp;录</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { checkUser } from "@/api/user/index.js";
import { setToken } from "@/utils/auth";
import Cookies from "js-cookie";
export default {
  data() {
    var validateUser = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      logoImg: require("../assets/logo_new.png"),
      ruleForm: {
        username: "",
        password: "",
        checked: true,
      },
      rules: {
        username: [{ validator: validateUser, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
      },
    };
  },
  methods: {
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.ruleForm.checked) {
            Cookies.set("username", this.ruleForm.username, { expires: 30 });
            Cookies.set("password", this.ruleForm.password, {
              expires: 30,
            });
            Cookies.set("rememberMe", this.ruleForm.checked, {
              expires: 30,
            });
          } else {
            Cookies.remove("username");
            Cookies.remove("password");
            Cookies.remove("rememberMe");
          }
          var data = {
            username: that.ruleForm.username,
            //password: that.$md5(that.ruleForm.password),
            password: that.ruleForm.password,
          };
          checkUser(data)
            .then((res) => {
              if (res.code === 200) {
                setToken(res.result);
                that.$message({
                  message: "登录成功",
                  type: "success",
                });
                that.$router.push({ path: "/home" });
              } else {
                that.$message.error(res.message);
              }
            })
            .catch((e) => {
              that.$message.error(e);
            });
        }
      });
    },
    getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get("rememberMe");
      this.ruleForm = {
        username: username === undefined ? this.ruleForm.username : username,
        password: password === undefined ? this.ruleForm.password : password,
        checked: rememberMe === undefined ? false : Boolean(rememberMe),
      };
    },
  },
  created() {
    this.getCookie();
  },
};
</script>
<style lang="scss">
/* 登录界面窗体 */
.login {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;
  background: url(../assets/BJ.jpg) no-repeat;
  background-size: 100% 100%;

  .loginTitle {
    width: 100%;
    margin: 0 0 22.6px 0;
    padding: 0;
    font-size: 41.6px;
    color: #00e1eb;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loginForm {
    width: 640px;
    height: 432px;
    background: url(../assets/KT.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: column;
    margin: 0 0 102.4px 0;

    .ruleForm {
      width: 80%;
      top: 6rem;

      .el-input .el-input__inner {
        background: rgba(6, 135, 205, 0.3);
        border: 1px solid #0ba1f8;
        color: whitesmoke;
        padding-left: 50px;
      }

      .el-form-item .el-checkbox__inner {
        background-color: #0687cd;
        border-color: #0ba1f8;
        width: 16px;
        height: 16px;
      }

      .el-form-item .el-checkbox__label {
        color: #68889d;
        font-size: 16px;
      }

      .el-form-item .el-link--inner {
        color: #68889d;
        font-size: 16px;
      }

      .el-input__icon {
        color: #00e1eb;
        font-size: 22.4px;
      }

      .el-input__prefix {
        left: 18px;
      }
    }

    .loginInfo {
      width: 100%;
      height: 32px;
      line-height: 32px;
      font-size: 32px;
      text-align: center;
      color: #2a9bad;
      font-family: "Courier New", Courier, monospace;
      font-weight: bold;
    }

    .loginBtn {
      width: 100%;
      height: 44.8px;
      background: #00e1eb;
      border: 1px solid #00bfbb;
      font-size: 28.8px;
      font-family: "Courier New", Courier, monospace;
      font-weight: bold;
      color: #0e4c65;
    }
  }
}
</style>
